import { isCalendarDateValue } from "../../../common/dashboard/CalendarDateInput";
import { getChamberLocalDateInputValue } from "../../Invoicing/invoiceDueDate";

// IF10 Q21: the Record Member Payment date defaults to, and cannot be later
// than, today in the chamber's own time zone. The browser's UTC date
// (toISOString) is one day ahead in the evening in the Americas.
export const getMemberManualPaymentLatestDate = ({
  timeZone,
  nowUtcMilli,
}: {
  timeZone?: string | null;
  nowUtcMilli?: number;
}): string => getChamberLocalDateInputValue({ timeZone, nowUtcMilli });

export const memberManualPaymentDateErrorMessage =
  "Select a payment date. It cannot be later than today.";

export const getMemberManualPaymentDateError = (
  receivedDate: string,
  latestDate: string,
): string =>
  !isCalendarDateValue(receivedDate) || (latestDate && receivedDate > latestDate)
    ? memberManualPaymentDateErrorMessage
    : "";
